import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditMenuDialogData {
  name: string;
  description: string;
}

export interface EditMenuDialogResult {
  name: string;
  description: string;
}

@Component({
  selector: 'app-edit-menu-dialog',
  standalone: false,
  templateUrl: './edit-menu-dialog.component.html',
  styleUrl: './edit-menu-dialog.component.scss',
})
export class EditMenuDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<
      EditMenuDialogComponent,
      EditMenuDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: EditMenuDialogData
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
    });

    this.form.patchValue({
      name: data?.name ?? '',
      description: data?.description ?? '',
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    if (this.form.invalid) return;

    this.dialogRef.close({
      name: (this.form.value.name ?? '').trim(),
      description: (this.form.value.description ?? '').trim(),
    });
  }
}
